import qs from 'qs';
import { useEffect, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom-v5-compat';

import SessionClientOnboard from 'dashboard/lib/clients/SessionClientOnboard';
import { MessageType } from 'dashboard/lib/interfaces/Message';
import { PasswordReset } from 'dashboard/models/password-reset';
import { showMessage } from 'dashboard/redux/actions/messages';
import DashboardPasswordResetConfirmView from 'dashboard/views/DashboardPasswordResetConfirmView';
import { ApiEndpoint, ApiModel } from 'lib/interfaces/api';

const DashboardPasswordResetConfirmRoute = (props: PropsFromRedux) => {
  const navigate = useNavigate();
  const location = useLocation();

  const { token: passwordResetId, confirmation_code: confirmationCode } = qs.parse(
    location.search,
    {
      ignoreQueryPrefix: true,
    },
  ) as { token: string; confirmation_code: string };

  const [passwordReset, setPasswordReset] = useState(undefined);

  useEffect(() => {
    (async () => {
      let loadedPasswordReset;
      if (passwordResetId && confirmationCode) {
        try {
          loadedPasswordReset = (
            await SessionClientOnboard.getResource<PasswordReset>(
              ApiEndpoint.PasswordReset,
              passwordResetId,
            )
          ).data;
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          setPasswordReset(loadedPasswordReset);
        } catch {
          // Error handled by checking loaded object below
        }
      }

      if (!loadedPasswordReset) {
        props.showMessage(
          'Your password reset expired, please request a new one',
          MessageType.Failure,
          true,
        );
        navigate('/dashboard/password-reset');
      }
    })();
  }, [passwordResetId]);

  const confirmPasswordReset = async ({
    password,
    passwordConfirmation,
  }: {
    password: string;
    passwordConfirmation: string;
  }) => {
    try {
      await SessionClientOnboard.postResourceAction<PasswordReset>(
        {
          type: ApiModel.PasswordResetEmail,
          attributes: {
            'confirmation-code': confirmationCode,
          },
          /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
          id: passwordReset.id,
        },
        'confirm',
        {
          meta: {
            password,
            'password-confirmation': passwordConfirmation,
          },
        },
      );
      props.showMessage('Password successfully reset!', MessageType.Success, true);
      navigate('/dashboard');
    } catch {
      props.showMessage(
        'Your password reset has expired, please request a new one',
        MessageType.Failure,
        true,
      );
      navigate('/dashboard/password-reset');
    }
  };

  if (passwordReset == null) {
    return null;
  }

  return <DashboardPasswordResetConfirmView confirmPasswordReset={confirmPasswordReset} />;
};

const mapDispatchToProps = {
  showMessage,
};

const connector = connect(null, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(DashboardPasswordResetConfirmRoute);
